import { render } from "./ManageProposal.vue?vue&type=template&id=6fbc38bc"
import script from "./ManageProposal.vue?vue&type=script&lang=js"
export * from "./ManageProposal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/ManageProposal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6fbc38bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6fbc38bc', __exports__)) {
    api.reload('6fbc38bc', __exports__)
  }
  
  module.hot.accept("./ManageProposal.vue?vue&type=template&id=6fbc38bc", () => {
    api.rerender('6fbc38bc', render)
  })

}


export default __exports__